/**
 * <story-video> — click-to-play cover for the Behind The Collection video row.
 *
 * The video ships with preload="none" and a poster/play cover on top. On the
 * first click we start playback and fade the cover away, so the (potentially
 * large) video only downloads when the shopper chooses to watch.
 *
 * Progressive enhancement: without JS the native controls are still present
 * under the cover; if this script fails the video remains a valid <video>.
 */
if (!customElements.get('story-video')) {
  customElements.define(
    'story-video',
    class StoryVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.cover = this.querySelector('.story-row__video-cover');
        if (!this.video || !this.cover) return;

        this.cover.addEventListener('click', () => this.play());
      }

      play() {
        this.setAttribute('data-playing', '');

        // Ensure the native controls are available once the cover lifts.
        this.video.setAttribute('controls', '');

        const started = this.video.play();
        if (started && typeof started.catch === 'function') {
          started.catch(() => {
            // Autoplay blocked or interrupted — the cover is already gone and
            // the native controls are visible, so the shopper can hit play.
          });
        }

        // Move focus to the player for keyboard users.
        if (typeof this.video.focus === 'function') {
          this.video.focus({ preventScroll: true });
        }
      }
    }
  );
}
